import { createAction } from '@reduxjs/toolkit';

const setSelectedTillOption = createAction('tills/selected/set');
const setTills = createAction('tills/list/set');

export { setTills, setSelectedTillOption };
